import { Component } from '@angular/core';

@Component({
    selector: 'bergh-remove-account',
    templateUrl: './remove-account.component.html',
    styleUrls: ['./remove-account.component.scss'],
    standalone: false
})
export class RemoveAccountComponent {
  constructor() { }
}
